import { Question } from '../../../redux/test/type'

const determineButtonVariant = (qtn: Question) => {
  const isAnswerCorrect =
    qtn?.submittedAnswered?.toLocaleLowerCase() ===
    qtn?.correctAnswer?.toLocaleLowerCase()

  const variantSuccess = qtn?.submittedAnswered && isAnswerCorrect
  const variantInCorrect = qtn?.submittedAnswered && !isAnswerCorrect
  const variantReview = qtn?.isMarkedForReview ? 'warning' : 'outline-secondary'
  const variantError = variantInCorrect ? 'danger' : variantReview

  return qtn?.answer || variantSuccess ? 'success' : variantError
}

export default determineButtonVariant
